import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { decrypter, crypter } from "../../webutils/webutils";
export const PrepareHomeView = (props) => {
  const [filterPlant, setFilterPlant] = useState([]);
  const [isFilterDdl, setIsFilterDdl] = useState(false);
  const [selectedPlant, setSelectedPlant] = useState([]);
  const [filterSearchInput, setFilterSearchInput] = useState("");
  const [appliedFilter, setAppliedFilter] = useState([]);
  const [isPopup, setIsPopup] = useState(false);
  const [ismPopup, setIsmPopup] = useState(false);
  const [islPopup, setIslPopup] = useState(false);
  const [isAllCourse, setIsAllCourse] = useState(false);
  const homeDataItems = props.homeData;
  
  const defaultFilterList = props.defaultData[0];
  const homeDataItem = props.homeData[0];
  const courses = homeDataItem.courses;
  const paidcourses = homeDataItem.paidcourses;
  const uid = homeDataItem.uid;
  const group_id= localStorage.getItem("group_id");

  let broughttrainging = 0;
  let avaltrainging = 0;
  courses.map((items, index) => {
    if (items.has_paid == 0) {
      avaltrainging = avaltrainging + 1;
    }
    if (items.has_paid == 1) {
      broughttrainging = broughttrainging + 1;
    }
  });
  const statuses = {
    completed: "status completed",
    "quiz pending": "status ed_quiz",
    "in progress": "status inprogress",
    "to do": "status todo",
    "": "status todo",
  };

  const fourcourses = paidcourses.map((course, index) => {
    if (index < 3) {
      return (
        <div key={course.id} className="prepare-col 1">
          <Link
            className="prp-card"
            to={
              homeDataItem.is_first_training == 1
                ? "/course-walkthrough"
                : course.cardStatus.toLowerCase() === "quiz pending"
                ? homeDataItem.is_first_quiz == 1
                  ? `/training-courses/${course.course_slug}`
                  : `/training-courses/${course.course_slug}`
                : `/training-courses/${course.course_slug}`
            }
          >
            <div className="prp-img-div green-bg">
              <img
                src={
                  require(`../../assets/img/training-card/${course.course_icon}`)
                    .default
                }
                className="icon-img"
                alt={course.course_name}
              />
              {"cardStatus" in course && (
                <span className={statuses[course.cardStatus.toLowerCase()]}>
                  {course.cardStatus && course.cardStatus !== ""
                    ? course.cardStatus
                    : "To Do"}
                </span>
              )}
            </div>
            <div className="prp-text-div">{course.course_name}</div>
          </Link>
        </div>
      );
    }
  });
  const allcourses = paidcourses.map((course) => {
    return (
      <div key={course.id} className="prepare-col 2">
        <Link
          className="prp-card"
          to={
            homeDataItem.is_first_training == 1
              ? "/course-walkthrough"
              : course.cardStatus.toLowerCase() === "quiz pending"
              ? homeDataItem.is_first_quiz == 1
                ? `/training-courses/${course.course_slug}`
                : `/training-courses/${course.course_slug}`
              : `/training-courses/${course.course_slug}`
          }
        >
          <div className="prp-img-div green-bg">
            <img
              src={
                require(`../../assets/img/training-card/${course.course_icon}`)
                  .default
              }
              className="icon-img"
              alt={course.course_name}
            />
            {"cardStatus" in course && (
              <span className={statuses[course.cardStatus.toLowerCase()]}>
                {course.cardStatus && course.cardStatus !== ""
                  ? course.cardStatus
                  : "To Do"}
              </span>
            )}
          </div>
          <div className="prp-text-div">{course.course_name}</div>
        </Link>
      </div>
    );
  });
  const allcoursesliting = paidcourses.map((course) => {
    return (
      <div key={course.id} className="indx-home-list-li">
        <span className="right-angle">
          <img
            src={
              require("../../assets/img/home-index/green-right-arrow.svg")
                .default
            }
            alt="true"
          />
        </span>
        <span className="text green">
          {course.cardStatus.toLowerCase() === "completed"
            ? "Go to your"
            : course.cardStatus.toLowerCase() === "quiz pending"
            ? "Continue your"
            : course.cardStatus.toLowerCase() === "in progress"
            ? "Continue your"
            : "Start your"}
          <Link
            to={
              course.cardStatus.toLowerCase() === "quiz pending"
                ? `/training-courses/${course.course_slug}`
                : `/training-courses/${course.course_slug}`
            }
            className="link"
          >
            {course.course_name}
          </Link>
          {course.cardStatus.toLowerCase() === "quiz pending"
            ? "training quiz"
            : "training course"}
        </span>
        <span
          className={
            course.cardStatus.toLowerCase() === "completed"
              ? "work-status green"
              : course.cardStatus.toLowerCase() === "quiz pending"
              ? "work-status orange"
              : course.cardStatus.toLowerCase() === "in progress"
              ? "work-status orange"
              : "work-status green"
          }
        >
          {course.cardStatus.toLowerCase() === "completed"
            ? "Completed"
            : course.cardStatus.toLowerCase() === "quiz pending"
            ? "In Progress"
            : course.cardStatus.toLowerCase() === "in progress"
            ? "In Progress"
            : "To Do"}
        </span>
      </div>
    );
  });

  const [allPlants, setAllPlants] = useState(defaultFilterList.all_plants);
  const [filterAllPlants, setFilterAllPlants] = useState(homeDataItem.all_plants);

 

  const HandleAllCourseView = () => {
    setIsAllCourse(!isAllCourse);
  };
  const clearAllFilter = () => {
    setSelectedPlant([]);
  };
  const HandlePopup = () => {
    setIsPopup(true);
  };
  const HandlePopupm = () => {
    setIsmPopup(true);
  };
  const HandlePopuNo = () => {
    return true;
  };

  const HandlePopupl = () => {
    setIslPopup(true);
  };
  const handleInput = (val) => {
    if (val == "all" && selectedPlant.length < allPlants.length) {
      let tmpArr = [];
      allPlants.forEach((el) => {
        tmpArr.push(el.id);
      });
      setSelectedPlant(tmpArr);
    } else if (val == "all" && selectedPlant.length === allPlants.length) {
      setSelectedPlant([]);
    } else if (selectedPlant.indexOf(val) === -1) {
      let tmpArr = [...selectedPlant];
      tmpArr.push(val);
      setSelectedPlant(tmpArr);
    } else if (selectedPlant.indexOf(val) > -1) {
      let tmpArr = selectedPlant.filter((item) => item !== val);
      setSelectedPlant(tmpArr);
    }
  };

  const applyFilter = () => {
    setFilterSearchInput("");
    props.onFilter(selectedPlant);
    setAppliedFilter(selectedPlant);
    setIsFilterDdl(false);
  };

  const handleFilterSearch = (e) => {
    let val = e.target.value;
    setFilterSearchInput(val);
    if (val.length > 0) {
      let tmpFilterArr = allPlants.filter((item) => {
        let tmpStr = item.plant_name.toLocaleLowerCase();
        let tmpVal = val.toLocaleLowerCase();
        return tmpStr.startsWith(tmpVal);
      });
      setFilterPlant(tmpFilterArr);
    } else {
      setFilterPlant(allPlants);
    }
  };
  const clearSerachFilter = () => {
    setFilterSearchInput("");
  };

  useEffect(() => {
    setSelectedPlant(appliedFilter);
  }, [isFilterDdl]);

  useEffect(() => {
    setFilterAllPlants(homeDataItem.all_plants);
  }, [props.homeData]);
  return (
    <>
      <div className="prepare-home-wrapper">
        <h1 className="prepare-top-h1">
          <img
            src={
              require("../../assets/img/prepare-home/my-trainging-h1.svg")
                .default
            }
            alt="true"
          />
          <span>My Trainings</span>
        </h1>

        <div className="prepare-row">
        {(uid != 45 && group_id!=14) ? ( 
          <>
        <div className="prepare-col 0">
            <a className="prp-card" href="/skill-assessment">
              <div className="prp-img-div green-bg">
                <img
                  src={
                    require("../../assets/img/prepare-home/skills-assessment.svg")
                      .default
                  }
                  className="icon-img"
                  alt="Skills Assessment"
                />
                <span className={
               homeDataItem.skill_assessment_status === "Completed"
              ? "status completed"
              : homeDataItem.skill_assessment_status === "In Progress"
              ? "status inprogress"
              : "status todo"
                }>{homeDataItem.skill_assessment_status}</span>
              </div>
              <div className="prp-text-div">Skills Assessment</div>
            </a>
          </div>

         <div className="prepare-col 0">
              {/* card has two sections
                  prp-img-div
                  prp-text-div
              */}
              <a className="prp-card" href="/powerbi/skillsassessment/analytics">
                <div className="prp-img-div green-bg">
                  <img
                    src={
                      require("../../assets/img/training-card/education-anaytics.svg")
                        .default
                    }
                    className="icon-img"
                    alt="Skills Assessment Analytics"
                  />
                </div>
                <div className="prp-text-div">Skills Assessment Analytics</div>
              </a>
            </div>
			<div className="prepare-col 0">
            <a className="prp-card" href="/analytics/education">
              <div className="prp-img-div green-bg">
                <img
                  src={
                    require("../../assets/img/prepare-home/education-analytics.svg")
                      .default
                  }
                  className="icon-img"
                  alt="Education Analytics"
                />
                {/* <span className="status todo">To Do</span> */}
              </div>
              <div className="prp-text-div">Education Analytics</div>
            </a>
          </div>
          </> 
          ):(
            <></>
          )}
          {broughttrainging == 1 ? (
            <>
              {allcourses}
              <div className="prepare-col 3">
                <Link to="/training-courses" className="prp-card">
                  <div className="prp-img-div green-bg">
                    <img
                      src={
                        require("../../assets/img/home-index/course_sections-icon-1.svg")
                          .default
                      }
                      className="icon-img"
                      alt="true"
                    />
                  </div>
                  <div className="prp-text-div">Available training courses</div>
                </Link>
              </div>
            </>
          ) : (
            <>
              {!isAllCourse ? (
                <>
                  {fourcourses}
                  {broughttrainging > 4 && (
                    <div className="prepare-col 3 view-all-cards">
                      <div
                        className="btn-show-all-course-wrapper"
                        onClick={HandleAllCourseView}
                      >
                        <div className="view-img-div">
                          <img
                            src={
                              require("../../assets/img/home-index/btn-view-all-course.svg")
                                .default
                            }
                            alt="view-img"
                          />
                        </div>
                        <p className="prp-text-div">
                          + View all courses
                          {/* See All of my courses */}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>{allcourses}</>
              )}
            </>
          )}
          {homeDataItem.training_tour == 0 && broughttrainging < 2 && (
            <div className="prepare-col 4">
              <Link to="/training-walkthrough" className="prp-card">
                <div className="prp-img-div green-bg">
                  <img
                    src={
                      require("../../assets/img/home-index/course_sections-icon-2.svg")
                        .default
                    }
                    className="icon-img"
                    alt="true"
                  />
                </div>
                <div className="prp-text-div">Training Courses</div>
              </Link>
            </div>
          )}
        </div>
        {homeDataItem.total_plant > 0 && (
          <div className="prp-plant-div">
            <h1 className="prepare-top-h1">
              <img
                src={
                  require("../../assets/img/prepare-home/measure.svg").default
                }
                alt="true"
              />
              <span>My Plants</span>

              {homeDataItem.total_plant > 1 && (
                <div className="prp-filter-wrapper">
                  <button
                    className={`prp-fltr-btn ${
                      isFilterDdl
                        ? "active"
                        : selectedPlant.length > 0
                        ? "default"
                        : ""
                    }`}
                    onClick={() => setIsFilterDdl(!isFilterDdl)}
                  >
                    <span className="down-arrow-icon">
                      <svg
                        viewBox="0 0 14 9"
                        className={`srch-icon`}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M4.5 8H9.5C9.77614 8 10 8.22386 10 8.5C10 8.74546 9.82312 8.94961 9.58988 8.99194L9.5 9H4.5C4.22386 9 4 8.77614 4 8.5C4 8.25454 4.17688 8.05039 4.41012 8.00806L4.5 8H9.5H4.5ZM2.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.74546 11.8231 4.94961 11.5899 4.99194L11.5 5H2.5C2.22386 5 2 4.77614 2 4.5C2 4.25454 2.17688 4.05039 2.41012 4.00806L2.5 4H11.5H2.5ZM0.5 0H13.5C13.7761 0 14 0.223858 14 0.5C14 0.74546 13.8231 0.949608 13.5899 0.991944L13.5 1H0.5C0.223858 1 0 0.776142 0 0.5C0 0.25454 0.176875 0.0503916 0.410124 0.00805569L0.5 0H13.5H0.5Z" />
                      </svg>
                    </span>
                    <span>
                      {selectedPlant.length > 0
                        ? `Plant Selected (${selectedPlant.length})`
                        : "All Plants"}
                    </span>
                  </button>
                  <div
                    className={`prp-filter-box ${isFilterDdl ? "active" : ""}`}
                  >
                    <div className="header-top">
                      <div
                        className={`prp-search-box ${
                          filterSearchInput.length > 0 ? "active" : ""
                        }`}
                      >
                        <label>
                          <svg
                            className="srch-icon"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.45341 0C2.89291 0 0 2.88889 0 6.44445C0 10 2.89291 12.8889 6.45341 12.8889C7.98887 12.8889 9.41307 12.3556 10.5035 11.4444L14.8651 15.8C15.1321 16.0667 15.5549 16.0667 15.7997 15.8C16.0668 15.5333 16.0668 15.1333 15.7997 14.8667L11.4381 10.5111C12.3505 9.4 12.8846 7.97778 12.8846 6.44445C12.9068 2.88889 10.0139 0 6.45341 0ZM6.45341 1.33333C9.27955 1.33333 11.5716 3.62222 11.5716 6.44445C11.5716 9.26667 9.27955 11.5556 6.45341 11.5556C3.62726 11.5556 1.33519 9.26667 1.33519 6.44445C1.33519 3.6 3.62726 1.33333 6.45341 1.33333Z"
                              fill="#A6A7AD"
                            />
                          </svg>

                          <input
                            type="text"
                            placeholder="Start typing to search"
                            value={filterSearchInput}
                            onChange={(e) => handleFilterSearch(e)}
                          />
                          <button
                            className="clear-all-btn"
                            onClick={clearSerachFilter}
                          >
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx={8} cy={8} r={8} fill="#7D868C" />
                              <path
                                d="M11.7172 5.08856C11.8734 4.93235 11.8734 4.67908 11.7172 4.52287L11.4771 4.28284C11.3209 4.12663 11.0677 4.12663 10.9114 4.28284L8.28284 6.91144C8.12663 7.06765 7.87337 7.06765 7.71716 6.91144L5.08856 4.28284C4.93235 4.12663 4.67908 4.12663 4.52287 4.28284L4.28284 4.52287C4.12663 4.67908 4.12663 4.93235 4.28284 5.08856L6.91144 7.71716C7.06765 7.87337 7.06765 8.12663 6.91144 8.28284L4.28284 10.9114C4.12663 11.0677 4.12663 11.3209 4.28284 11.4771L4.52287 11.7172C4.67908 11.8734 4.93235 11.8734 5.08856 11.7172L7.71716 9.08856C7.87337 8.93235 8.12663 8.93235 8.28284 9.08856L10.9114 11.7172C11.0677 11.8734 11.3209 11.8734 11.4771 11.7172L11.7172 11.4771C11.8734 11.3209 11.8734 11.0677 11.7172 10.9114L9.08856 8.28284C8.93235 8.12663 8.93235 7.87337 9.08856 7.71716L11.7172 5.08856Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </label>
                      </div>
                    </div>
                    <div className="body-list">
                      {filterSearchInput.length < 1 ? (
                        <>
                          {/* selected plant list map */}
                          {allPlants.map((item, i) => (
                            <div key={i}>
                              {selectedPlant.length === allPlants.length &&
                                i === 0 &&
                                filterSearchInput.length < 1 && (
                                  <label className="chk-label">
                                    <input
                                      type="checkbox"
                                      checked={true}
                                      onClick={() => handleInput("all")}
                                    />
                                    <span className="svg-icon">
                                      <img
                                        src={
                                          require("../../assets/img/prepare-home/chk-white.svg")
                                            .default
                                        }
                                        alt=""
                                      />
                                    </span>
                                    <span className="plant-chk-txt">
                                      All Plant
                                    </span>
                                  </label>
                                )}
                              {selectedPlant.indexOf(item.id) > -1 &&
                                selectedPlant.length > 0 &&
                                selectedPlant.length < allPlants.length &&
                                i === 0 && (
                                  <span className="plant-bold-txt">
                                    SELECTED PLANTS
                                  </span>
                                )}
                              {selectedPlant.indexOf(item.id) > -1 && (
                                <label className="chk-label">
                                  <input
                                    type="checkbox"
                                    checked={true}
                                    value={item}
                                    onClick={() => handleInput(item.id)}
                                  />
                                  <span className="svg-icon">
                                    <img
                                      src={
                                        require("../../assets/img/prepare-home/chk-white.svg")
                                          .default
                                      }
                                      alt=""
                                    />
                                  </span>
                                  <span className="plant-chk-txt">
                                    {item.plant_name}
                                  </span>
                                </label>
                              )}
                            </div>
                          ))}
                          {/* selected plant list map end*/}
                          {/* all plants list map and unselected list map*/}
                          {allPlants.map((item, i) => (
                            <div key={i}>
                              {selectedPlant.length == 0 && i === 0 && (
                                <label className="chk-label">
                                  <input
                                    type="checkbox"
                                    onChange={() => handleInput("all")}
                                  />
                                  <span className="svg-icon">
                                    <img
                                      src={
                                        require("../../assets/img/prepare-home/chk-white.svg")
                                          .default
                                      }
                                      alt=""
                                    />
                                  </span>
                                  <span className="plant-chk-txt">
                                    All Plant
                                  </span>
                                </label>
                              )}

                              {selectedPlant.length > 0 &&
                                selectedPlant.length < allPlants.length &&
                                i == 0 && (
                                  <span className="plant-bold-txt">
                                    OTHER PLANTS
                                  </span>
                                )}

                              {selectedPlant.indexOf(item.id) === -1 && (
                                <label className="chk-label">
                                  <input
                                    type="checkbox"
                                    value={item.id}
                                    id={`plantInput${i}`}
                                    onChange={() => handleInput(item.id)}
                                  />
                                  <span className="svg-icon">
                                    <img
                                      src={
                                        require("../../assets/img/prepare-home/chk-white.svg")
                                          .default
                                      }
                                      alt=""
                                    />
                                  </span>
                                  <span className="plant-chk-txt">
                                    {item.plant_name}
                                  </span>
                                </label>
                              )}
                            </div>
                          ))}
                          {/* all plants list map and unselected list map end*/}
                        </>
                      ) : (
                        <>
                          {filterPlant.map((item, i) => (
                            <label className="chk-label">
                              <input
                                type="checkbox"
                                defaultChecked={
                                  selectedPlant.indexOf(item.id) > -1
                                }
                                value={item.id}
                                onChange={() => handleInput(item.id)}
                              />
                              <span className="svg-icon">
                                <img
                                  src={
                                    require("../../assets/img/prepare-home/chk-white.svg")
                                      .default
                                  }
                                  alt=""
                                />
                              </span>
                              <span className="plant-chk-txt">
                                {item.plant_name}
                              </span>
                            </label>
                          ))}
                        </>
                      )}
                    </div>
                    {/* body-list end */}
                    <div className="footer-bottom">
                      <button className="btn-ft clear" onClick={clearAllFilter}>
                        Clear all
                      </button>
                      <button className="btn-ft apply" onClick={applyFilter}>
                        Apply
                      </button>
                    </div>
                  </div>
                  {/* prp-filter-box end */}
                </div>
              )}
            </h1>
            {filterAllPlants.map((plant, repIndex) => (
              <>
                <div className="prepare-row">
                  <div className="prepare-full-col">
                    <div className="plant-name-div">
                      <span className="plant-img">
                      {(plant.id != 27 && plant.id != 33 && plant.id != 38) &&(
                          <img
                            src={`https://apishowcasen.smarterchains.com/assets/img/country/${plant.slug}.svg`}
                            alt=""
                          />
                        )}
                        {(plant.id == 27 || plant.id==33 || plant.id==38) && (
                          <img
                            src={`https://apishowcasen.smarterchains.com/assets/img/country/enterprise-wide.svg`}
                            alt=""
                          />
                        )}
                      </span>
                      <span className="plant-txt">{plant.plant_name}</span>
                    </div>
                  </div>
                  <div className="prepare-full-col">
                    <div className="prp-inner-card-row">
                      {(plant.is_completed == 0 && plant.id !=33 && plant.id !=38) && (
                        <div
                          className={`prepare-col plants ${
                            plant.mat == 0 && "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="PREPARE"
                            title="Digital Maturity Assessment"
                            status={plant.maturity_total_progress}
                            progress={plant.maturity_total_progress}
                            type="dma"
                            colorClass="blue-bg"
                            gourl={
                              plant.mat == 0
                                ? ""
                                : `assessment/${plant.plant_slug}`
                            }
                            otherFunction={
                              plant.mat == 0 ? HandlePopupm : HandlePopuNo
                            }
                          />
                        </div>
                      )}
                      {plant.is_completed == 1 && (
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 &&
                            plant.mat == 0 &&
                            plant.loss == 0 &&
                            "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="PREPARE"
                            title="Digital Maturity Assessment"
                            headerImg={
                              require("../../assets/img/prepare-home/training-course.svg")
                                .default
                            }
                            status={"results-ready"}
                            type="dma"
                            colorClass="blue-bg"
                            isRoadmapResult="Maturity Index"
                            savings={plant.indexscore}
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `result/${plant.plant_slug}`
                            }
                            otherFunction={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? HandlePopupm
                                : HandlePopuNo
                            }
                          />
                        </div>
                      )} 
					  
					  {/* Technology Adoption card start */}
					   {(plant.id ==26) && (
                          <div
                            className={`prepare-col plants ${
                              plant.mat == 0 && "disabled"
                            }`}
                          >
                            <PlantCard
                              cardType="PREPARE"
                              type="techAdop"
                              title="Technology Adoption"
                              status={"results-ready"}
                              colorClass="blue-bg"
                              gourl={"/powerbi/technology-adoption/display"}
                              otherFunction={HandlePopup}
                            />
                          </div>
						   )}
                          {/* Technology Adoption card end */}
                      {(plant.has_businesscase == 0 && plant.id !=33 && plant.id !=38) && (
					   <>
                        <div
                          className={`prepare-col plants ${
                            plant.loss == 0 && "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="PREPARE"
                            title="Loss Analysis"
                            status={plant.loss_total_progress}
                            progress={plant.loss_total_progress}
                            colorClass="blue-bg"
                            type="loss"
                            gourl={plant.loss == 0 ? "" : `${plant.bclines}`}
                            otherFunction={
                              plant.loss == 0 ? HandlePopupl : HandlePopuNo
                            }
                          />
                        </div>
						 </>
                      )}

                      {plant.has_businesscase == 1 && (
					   <>
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 &&
                            plant.mat == 0 &&
                            plant.loss == 0 &&
                            "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="PREPARE"
                            title="Loss Analysis"
                            status={"results-ready"}
                            colorClass="blue-bg"
                            type="loss"
                            isRoadmapResult="Identified Losses"
                            savings={plant.identified_losses}
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `powerbi/lossAnalysis/${plant.plant_slug}`
                            }
                            otherFunction={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? HandlePopupl
                                : HandlePopuNo
                            }
                          />
                        </div>
						 </>
                      )} 
					  <div
                            className={`prepare-col plants ${
                              homeDataItem.hideuser == 1 && "disabled"}`}>
                          <PlantCard
                            cardType="DEFINE"
                            title="Roadmap Configurator"
                            status={"not-started"}
                            colorClass="orange-bg"
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `roadmapconfigurator/${crypter(plant.plant_slug)}`
                            }
                           
                          />
                          </div>
                      {(plant.has_bdashhboard == 0 && plant.id !=33 && plant.id !=38) && (
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 && "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="DEFINE"
                            title="Business Case Dashboard"
                            status={
                              plant.maturity_total_progress == 100 &&
                              plant.loss_total_progress == 100
                                ? 50
                                : "not-started"
                            }
                            colorClass="orange-bg"
                            gourl={``}
                            otherFunction={HandlePopup}
                          />
                        </div>
                      )}
                      {plant.has_bdashhboard == 1 && (
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 &&
                            plant.mat == 0 &&
                            plant.loss == 0 &&
                            "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="DEFINE"
                            title="Business Case Dashboard"
                            status={"results-ready"}
                            colorClass="orange-bg"
                            isRoadmapDiveTxt="Roadmap Deep Dive"
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `businesscase/${plant.plant_slug}`
                            }
                          />
                        </div>
                      )}
                      {plant.has_bdashhboard == 1 && (
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 &&
                            plant.mat == 0 &&
                            plant.loss == 0 &&
                            "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="DEFINE"
                            title="Roadmap Results"
                            status={"results-ready"}
                            colorClass="orange-bg"
                            isRoadmapResult="Annual Savings"
                            savings={plant.annual_savings}
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `powerbi/bresults/${plant.plant_slug}`
                            }
                          />
                        </div>
                      )}

                      {(plant.id != 27 && plant.id != 33 && plant.id != 38) && (
					  <>
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 &&
                            plant.mat == 0 &&
                            plant.loss == 0 &&
                            "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="EXECUTE"
                            title="Industry 4.0 Masterplanner"
                            status={0}
                            type="execute"
                            colorClass="yellow-bg"
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `weblivedata/${crypter(plant.plant_slug)}`
                            }
                          />
                        </div>
						
						
                          
                       
						</>
                      )}
					  {(plant.id == 33 || plant.id == 38) && (
                        <div
                          className={`prepare-col plants ${
                            homeDataItem.hideuser == 1 &&
                            plant.mat == 0 &&
                            plant.loss == 0 &&
                            "disabled"
                          }`}
                        >
                          <PlantCard
                            cardType="DEFINE"
                            title="Roadmap Business Case"
                            status={"results-ready"}
                            colorClass="orange-bg"
                            isRoadmapDiveTxt="Enterprise Industry 4.0"
                            gourl={
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0
                                ? ""
                                : `powerbi/broadmap/${plant.plant_slug}`
                            }
                          />
                        </div>
                      )}
					  
					  
					  {(plant.id == 33 || plant.id == 38) && (
                        <>
                          <div
                            className={`prepare-col plants ${
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0 &&
                              "disabled"
                            }`}
                          >
                            <PlantCard
                              cardType="EXECUTE"
                              title="Industry 4.0 Masterplanner"
                              status={0}
                              type="execute"
                              colorClass="yellow-bg"
                              gourl={
                                plant.mat == 0 && plant.loss == 0
                                  ? ""
                                  : `powerbi/masterplanner/${plant.plant_slug}`
                              }
                            />
                          </div>
						  
                        </>
                      )}
                      {plant.id == 27 && (
                        <>
                          <div
                            className={`prepare-col plants ${
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0 &&
                              "disabled"
                            }`}
                          >
                            <PlantCard
                              cardType="EXECUTE"
                              title="Industry 4.0 Masterplanner"
                              status={0}
                              type="execute"
                              colorClass="yellow-bg"
                              gourl={
                                plant.mat == 0 && plant.loss == 0
                                  ? ""
                                  : `projectdashboard/enterprise`
                              }
                            />
                          </div>
						  
                          <div
                            className={`prepare-col plants ${
                              homeDataItem.hideuser == 1 &&
                              plant.mat == 0 &&
                              plant.loss == 0 &&
                              "disabled"
                            }`}
                          >
                            <PlantCard
                              cardType="EXECUTE"
                              title="Loss Tracking"
                              customStatus={"2021 RESULTS"}
                              lossReduction={12.7}
                              type="execute"
                              colorClass="yellow-bg"
                              gourl={
                                plant.mat == 0 && plant.loss == 0
                                  ? ""
                                  : `analytics/losstrack`
                              }
                            />
                          </div>
                        </>
                      )}
                      <div className="border-bottom-1"></div>
                    </div>
                  </div>
                </div>
              </>
            ))}
            {/* prepare-row 1 end */}
          </div>
        )}
      </div>
      <BussinessCasePopup isPopup={isPopup} setIsPopup={setIsPopup} />
      <MatCasePopup ismPopup={ismPopup} setIsmPopup={setIsmPopup} />
      <LossCasePopup islPopup={islPopup} setIslPopup={setIslPopup} />
    </>
  );
};

const TraingingCard = (props) => {
  const { title, headerImg, url, status, colorClass, otherFunction } = props;
  const callOtherFunction = () => {
    if (otherFunction) {
      otherFunction();
    }
  };
  return (
    <>
      <ConditionalTag
        durl={props.durl}
        url={url}
        otherFunction={callOtherFunction}
      >
        <div className={`prp-img-div ${colorClass}`}>
          <img src={headerImg} className="icon-img" alt="Img" />
          {status == 100 ? (
            <span className="status completed">COMPLETED</span>
          ) : status > 0 && status < 100 ? (
            <span className="status inprogress">IN PROGRESS</span>
          ) : status == 0 ? (
            <span className="status todo">To do</span>
          ) : (
            ""
          )}
        </div>
        <div className="prp-text-div">
          {title}
          {/* max-character 49*/}
        </div>
      </ConditionalTag>
    </>
  );
};

const PlantCard = (props) => {
  const {
    title,
    url,
    customStatus,
    status,
    colorClass,
    cardType,
    type,
    progress,
    lossReduction,
    isRoadmapDiveTxt,
    isRoadmapResult,
    savings,
    otherFunction,
  } = props;
  const callOtherFunction = () => {
    if (otherFunction) {
      otherFunction();
    }
  };
  return (
    <>
      <ConditionalTag
        durl={props.durl}
        url={props.gourl}
        otherFunction={callOtherFunction}
      >
        <div className={`prp-img-div ${colorClass}`}>
          <div className="prp-card-img">
            <p>{cardType}</p>
            <img
              src={
                require(`../../assets/img/prepare-home/${
                  type == "dma"
                    ? `assessment-icon.svg`
                    : type == "loss"
                    ? "loss-icon.svg"
                    : type == "execute"
                    ? "prepare-execute.svg"
                    : type=="techAdop"
                    ? "tech-adoption-icon.svg"
                    :"business-icon.svg"
                }`).default
              }
              alt="Img"
            />
          </div>
          <div className="prp-card-porogress-div">
            {/* if roadmap deep dive text  in props*/}
            {isRoadmapDiveTxt && (
              <span className="txt-normal">{isRoadmapDiveTxt}</span>
            )}

            {/* if progress is 0 or greater than 0 in props  */}
            {progress > -1 && progress !== "undefined" ? (
              <span className="txt-normal">Progress</span>
            ) : (
              ""
            )}
            {progress > -1 && <span className="progress-num">{progress}%</span>}
            {/* loss reduction */}
            {lossReduction > -1 && lossReduction !== "undefined" ? (
              <span className="txt-normal">Loss Reduction</span>
            ) : (
              ""
            )}
            {lossReduction > -1 && (
              <span className="progress-num">{lossReduction}%</span>
            )}
            {/* loss reduction end */}
            {isRoadmapResult && (
              <>
                <span className="progress-num result">{savings}</span>
                <span className="txt-normal">{isRoadmapResult}</span>
              </>
            )}
          </div>

          {status == 100 ? (
            <span className="status completed">COMPLETED</span>
          ) : status > 0 && status < 100 ? (
            <span className="status inprogress">IN PROGRESS</span>
          ) : status == 0 ? (
            <span className="status todo">To do</span>
          ) : status == "not-started" ? (
            <span className="status not-started">NOT STARTED</span>
          ) : status == "results-ready" ? (
            <span className="status results-ready">RESULTS READY</span>
          ) : (
            ""
          )}
          {/* custom status */}
          {customStatus ? (
            <span className="status completed">{customStatus}</span>
          ) : (
            ""
          )}
        </div>
        <div className="prp-text-div">
          {title}
          {/* max-character 49*/}
        </div>
      </ConditionalTag>
    </>
  );
};

const ConditionalTag = (props) => {
  const { url, otherFunction, durl } = props;
  return (
    <>
      {url ? (
        <Link to={url} className="prp-card">
          {props.children}
        </Link>
      ) : durl ? (
        <a href={durl} className="prp-card">
          {props.children}
        </a>
      ) : (
        <div className="prp-card" onClick={otherFunction}>
          {props.children}
        </div>
      )}
    </>
  );
};

const BussinessCasePopup = (props) => {
  const { isPopup, setIsPopup } = props;
  const handleClose = () => {
    setIsPopup(false);
  };
  return (
    <div className={`prp-businesscase-popup-wrap ${isPopup ? "active" : ""}`}>
      <div className="prp-businesscase-popup">
        <button className="close-btn" onClick={handleClose}>
          <img
            src={
              require("../../assets/img/prepare-home/close-popup.svg").default
            }
            alt="Close Button"
          />
        </button>
        <div className="pop-body-wrap">
          <div className="img-box">
            <img
              src={
                require("../../assets/img/prepare-home/businesscase-pop.svg")
                  .default
              }
              alt="Businesscase"
            />
          </div>
          <h1 className="heading">
            Your Business case results are not ready yet.
          </h1>
          <p className="text">
            We will notify you when they will be available.
          </p>
          <button className="ok-btn" onClick={handleClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
const MatCasePopup = (props) => {
  const { ismPopup, setIsmPopup } = props;
  const handleClosem = () => {
    setIsmPopup(false);
  };
  return (
    <div className={`prp-businesscase-popup-wrap ${ismPopup ? "active" : ""}`}>
      <div className="prp-businesscase-popup">
        <button className="close-btn" onClick={handleClosem}>
          <img
            src={
              require("../../assets/img/prepare-home/close-popup.svg").default
            }
            alt="Close Button"
          />
        </button>
        <div className="pop-body-wrap">
          <div className="img-box">
            <img
              src={
                require("../../assets/img/prepare-home/businesscase-pop.svg")
                  .default
              }
              alt="Businesscase"
            />
          </div>
          <h1 className="heading">
            Your Maturity Assessment results are not ready yet.
          </h1>
          <p className="text">
            We will notify you when they will be available.
          </p>
          <button className="ok-btn" onClick={handleClosem}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
const LossCasePopup = (props) => {
  const { islPopup, setIslPopup } = props;
  const handleClosel = () => {
    setIslPopup(false);
  };
  return (
    <div className={`prp-businesscase-popup-wrap ${islPopup ? "active" : ""}`}>
      <div className="prp-businesscase-popup">
        <button className="close-btn" onClick={handleClosel}>
          <img
            src={
              require("../../assets/img/prepare-home/close-popup.svg").default
            }
            alt="Close Button"
          />
        </button>
        <div className="pop-body-wrap">
          <div className="img-box">
            <img
              src={
                require("../../assets/img/prepare-home/businesscase-pop.svg")
                  .default
              }
              alt="Businesscase"
            />
          </div>
          <h1 className="heading">
            Your Loss Analysis results are not ready yet.
          </h1>
          <p className="text">
            We will notify you when they will be available.
          </p>
          <button className="ok-btn" onClick={handleClosel}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
